import { useLogger } from '@booksy-com/vue-tools'
import { useTurnTrackerCheckInMode } from '@/components/turn-tracker/composables/check-in-mode'
import type { NavigationGuardNext, RouteLocationNormalizedLoaded } from 'vue-router'

const logger = useLogger('router.guard.turn-tracker-check-in-mode')
const CHECK_IN_MODE_ROUTE_NAME = 'turn-tracker.check-in-mode'

export default function turnTrackerCheckInMode (
  route: RouteLocationNormalizedLoaded,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext
) {
  logger.debug(route.path)

  const businessRoute = !!route.matched.find((r) => r.name === 'business')

  // shortcut: works only for business (sub-)routes
  if (!businessRoute) {
    return next()
  }

  const { isCheckInModeFeatureAvailable, isEnabled } = useTurnTrackerCheckInMode()
  const isCheckInModeRoute = route.matched.some((r) => r.name === CHECK_IN_MODE_ROUTE_NAME)

  if (isCheckInModeFeatureAvailable && isEnabled.value && !isCheckInModeRoute) {
    logger.debug('redirecting to "turn-tracker.check-in-mode" view...')
    return next({
      name: CHECK_IN_MODE_ROUTE_NAME,
      params: route.params,
    })
  }

  next()
}
